import { observer, useLocalObservable } from 'mobx-react';
import { useEffect, useState } from 'react';
import Pagination from '../../Pagination';
import './style.scss';
import ComplexNewsCommonModel from 'common-modules/general/Common/Logic/News/NewsCommon';
import { toJS } from 'mobx';
import { ResponseHomeNewsList } from 'common-modules/general/API/news/types';
import NoResultWithLabel from 'common-modules/general/Common/Components/NoResultWithLabel';
import { useHistory } from 'react-router-dom';
import { RoutesString } from 'common-modules/general/Config/routesString';

const News = observer(() => {
  const history = useHistory();
  const [searchValue, setSearchValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const { model: mainModel } = useLocalObservable(() => ({ model: new ComplexNewsCommonModel() }));

  useEffect(() => {
    mainModel.getData({});
  }, [mainModel]);

  const getSearchItem = () => {
    if (mainModel) {
      mainModel.getData({ page: currentPage, keyword: searchValue });
      setSearchValue('');
    }
  };

  // 페이지네이션 내 페이지 변경 시 state 감지
  useEffect(() => {
    if (mainModel) {
      mainModel.getData({ page: currentPage, keyword: searchValue });
    }
  }, [currentPage]);

  const handleClickNoticeItem = (data: ResponseHomeNewsList) => {
    /* s: 221108 외부링크 추가 */
    if(data.addrUrl == null) {
      history.push(`${RoutesString.SalesNewsDetail}/?id=${data.noUperWrtSral}`);
    } else {
      window.open(`${data.addrUrl}`);
    }
    /* e: 221108 외부링크 추가 */
  };

  const noticeListData = toJS(mainModel.mainData.data?.list);
  const totalCount = mainModel.mainData.data?.totalPage || 0;
  const totalElementCount = mainModel.mainData.data?.numberOfElements || 0;

  const renderList = () => {
    return (
      noticeListData &&
      noticeListData.map(item => {
        return (
          <tr onClick={() => handleClickNoticeItem(item)} key={item.noUperWrtSral}>
            <td>
              <div>
                <span className="txt">{item.sbjtNtcPlte}</span>
              </div>
            </td>
            <td>{item.dntRgst}</td>
          </tr>
        );
      })
    );
  };

  return (
    <div className="contents-news">
      <div id="content" role="main">
        <div className="mpii-vi01-container">
          <div className="border-container medium mlr-auto mb-120">
            <h1 className="section-title">새소식</h1>
            <div className="section-a medium mlr-auto news-search-with-number-container">
              <div>총 {totalElementCount}건</div>
              <div className="section-search clfix right">
                <div className="search-area">
                  <div className="input-custom">
                    <div className="input-control default">
                      <div className="input-area">
                        <div className="input">
                          <input value={searchValue} onChange={e => setSearchValue(e.target.value)} type="text" id="input-122" />
                          <label
                            htmlFor="input-122"
                            style={
                              searchValue.length > 1
                                ? {
                                    position: 'absolute',
                                    bottom: '2.375rem',
                                    fontSize: '0.875rem',
                                    transform: 'translate(0, 0)'
                                  }
                                : {}
                            }>
                            검색어 입력
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="button" onClick={getSearchItem}>
                    <i className="ico-searchp01" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="table-container board-type01 mb-60">
              {noticeListData && noticeListData.length > 0 ? (
                <table className="table-row">
                  <tbody>{renderList()}</tbody>
                </table>
              ) : (
                <NoResultWithLabel>결과가 없습니다.</NoResultWithLabel>
              )}
            </div>

            <Pagination limit={10} currentPage={currentPage} setCurrentPage={setCurrentPage} totalCount={totalCount * 10} />
          </div>
        </div>
      </div>
    </div>
  );
});

export default News;
